import React from 'react';
import { ArcStack } from '@src/core/ui';
import { useFlightProvider } from '@src/features/order/provider';
import { AttitudeIndicator, HeadingIndicator } from 'react-typescript-flight-indicators';
import { EnRouteIndicatorProps } from './types';

const EnRouteIndicator: React.FC<EnRouteIndicatorProps> = () => {
  const { attitudeEuler } = useFlightProvider();
    
  return (
    <ArcStack spacing={1} direction='column' justifyContent='center'>
      <ArcStack
        display='inline-flex'
        alignItems='center'
        justifyContent='center'
        sx={{
          overflow: 'hidden',
          borderRadius: '4px',
          border: (theme) => `0.5px solid ${theme.palette.border.muted}`,
        }}
      >
        <HeadingIndicator
          size='115px'
          showBox={false}
          heading={attitudeEuler?.yaw_deg}
        />
      </ArcStack>
      <ArcStack
        display='inline-flex'
        alignItems='center'
        justifyContent='center'
        sx={{
          overflow: 'hidden',
          borderRadius: '4px',
          border: (theme) => `0.5px solid ${theme.palette.border.muted}`,
        }}
      >
        <AttitudeIndicator 
          showBox={false}
          size='115px' 
          pitch={attitudeEuler?.pitch_deg} 
          roll={attitudeEuler?.roll_deg} />
      </ArcStack>
    </ArcStack>
  );
};

export default EnRouteIndicator;